import { atom } from 'recoil'

const gymBuilderState = atom<Dto.GymBuilder | null | undefined>({
  key: 'gym-builder',
  default: undefined,
})

export { gymBuilderState }
